module.exports = __webpack_public_path__ + "img/banner-product.a7ea45e.png";